import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { Router } from '@angular/router';
import { ExaminersClient, ExamReportsClient, SelectListResponse } from '../../../generated-client/generated-api-client';
import { ErrorProcessorService } from '../../../services/error-processor.service';

export interface AddExaminerModal {
  // email?: string;
  // idNumber?: string;
  examReportId: string;
}

@Component({
  selector: 'app-add-examiner-modal',
  templateUrl: './add-examiner-modal.component.html',
  styleUrls: ['./add-examiner-modal.component.sass'],
})
export class AddExaminerModalComponent
  extends SimpleModalComponent<AddExaminerModal, boolean>
  implements AddExaminerModal, OnInit
{
  email?: string = '';
  idNumber?: string = '';
  examReportId!: string;
  selectList!: SelectListResponse;
  isLoading: boolean = true;
  confirmed: boolean = false;
  private _selectedExaminerId: string = '';

  @Output() onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private examinerClient: ExaminersClient,
    private examReportClient: ExamReportsClient,
    private errorProcessorService: ErrorProcessorService
  ) {
    super();
  }

  ngOnInit() {
    this.examinerClient.getExaminersSelectListForExamReport(this.examReportId, undefined).subscribe(
      response => {
        this.selectList = response;
        this.isLoading = false;
      },
      error => this.errorProcessorService.processError(error)
    );
  }

  get selectedExaminerId() {
    return this._selectedExaminerId;
  }

  set selectedExaminerId(value: string) {
    if (value !== this._selectedExaminerId) {
      this._selectedExaminerId = value;
      this.examinerClient.info(value).subscribe(
        response => {
          this.email = response.email;
          this.idNumber = response.idNumber;
        },
        error => this.errorProcessorService.processError(error)
      );
    }
  }

  confirm() {
    if (!this.confirmed) {
      this.confirmed = true;
      this.examReportClient.assignExaminer(this.examReportId, this.selectedExaminerId).subscribe(
        response => {
          this.result = true;
          this.close();
          this.onConfirm.emit(this.result);
        },
        error => this.errorProcessorService.processError(error)
      );
    }
  }

  newExaminer() {
    this.close();
    this.router.navigate(['examiners/new/exam-report', this.examReportId]);
  }
}
